import { Pipe, PipeTransform } from '@angular/core';
import { DateUtility, RecurringJob } from '@jms/model';

@Pipe({
  name: 'toRecurringJobStatus',
  standalone: true
})
export class ToRecurringJobStatusPipe implements PipeTransform {

  transform(job: RecurringJob): string {

    const today = DateUtility.getDate(new Date);
    const endDate = DateUtility.getDate(job?.end);

    if (endDate < today) {
      return 'Expired';
    }

    if (job?.turnOn)
      return 'Active';

    if (!job?.turnOn)
      return 'Inactive'
  }

}
